import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { StrongPasswordMessageDirective } from '../password/directives/strong-password-message.directive';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { RejectDialogWithMsgComponent } from './components/reject-dialog-with-msg/reject-dialog-with-msg.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';

@NgModule({
  declarations: [ConfirmDialogComponent, ChangePasswordComponent, ResetPasswordComponent, RejectDialogWithMsgComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    TranslateModule,
    MatDividerModule,
    MatSelectModule,
    MatOptionModule,
    StrongPasswordMessageDirective
  ]
})
export class ConfirmDialogModule { }
